import { render } from "./Prices.vue?vue&type=template&id=44db2da1&scoped=true"
import script from "./Prices.vue?vue&type=script&lang=js"
export * from "./Prices.vue?vue&type=script&lang=js"

import "./Prices.vue?vue&type=style&index=0&id=44db2da1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44db2da1"]])

export default __exports__